import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import Layout from "./components/Layout/Layout";

import Login from "./Pages/Login/Login";
import ResetForm from "./Pages/Login/Resetform";
import VerifyEmail from "./Pages/Login/VerifyEmail";
import VerifyResetotp from "./Pages/Login/VerifyResetotp";
import Createnewpassword from "./Pages/Login/Createnewpassword";

import Dashboard from "./Pages/Dashboard/Dashboard";
import Users from "./Pages/Users/Users";
import Viewuser from "./Pages/Viewuser/Viewuser";
import Games from "./Pages/Games/Games";
import Chest from "./components/Games/Chest";
import SpinWheel from "./components/Games/SpinWheel";
import SalesInventory from "./Pages/SalesInventory/SalesInventory";
import Leaderboard from "./Pages/Leaderboard/Leaderboard";
import Notifications from "./Pages/Notification/Notification";
import AdminSettings from "./Pages/Admin Settings/AdminSettings";
import Editprofile from "./Pages/Admin Settings/Editprofile";
import ContactQueries from "./Pages/Contact Queries/ContactQueries";
import Coins from "./Pages/SalesInventory/Coins";
import Ads from "./Pages/Ads/Ads";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/Resetform" element={<ResetForm />} />
        <Route path="/VerifyEmail" element={<VerifyEmail />} />
        <Route path="/VerifyResetotp" element={<VerifyResetotp />} />
        <Route path="/Createnewpassword" element={<Createnewpassword />} />

        <Route path="/Layout" element={<Layout />}>
          <Route path="Dashboard" element={<Dashboard />} />
          <Route path="Users" element={<Users />} />
          <Route path="Viewuser/:id" element={<Viewuser />} />
          <Route path="Games" element={<Games />} />
          <Route path="Chest" element={<Chest />} />
          <Route path="Spin" element={<SpinWheel />} />
          <Route path="SalesInventory" element={<SalesInventory />} />
          <Route path="Leaderboard" element={<Leaderboard />} />
          <Route path="Ads" element={<Ads />} />
          <Route path="Notifications" element={<Notifications />} />
          <Route path="AdminSettings" element={<AdminSettings />} />
          <Route path="Editprofile" element={<Editprofile />} />
          <Route path="ContactQueries" element={<ContactQueries />} />
          <Route path="Coins" element={<Coins />} />
        </Route>
      </Routes>

      <Toaster />
    </Router>
  );
}

export default App;
